export default __webpack_public_path__ + "static/media/TTFExp.1bb9ea16.md";